module.exports = __webpack_public_path__ + "img/user.f25ff824.svg";